import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "o-section -gray-bg -front" }
const _hoisted_2 = { class: "o-container" }
const _hoisted_3 = { class: "o-row" }
const _hoisted_4 = { class: "o-col w-10/12" }
const _hoisted_5 = {
  id: "inventaire",
  class: "o-form js-lpdg-form",
  action: "#",
  method: "post"
}
const _hoisted_6 = { class: "o-row -gutter-xs o-form" }
const _hoisted_7 = { class: "o-col w-1/5" }
const _hoisted_8 = { class: "o-form-group__item" }
const _hoisted_9 = { class: "o-mselect__wrap" }
const _hoisted_10 = { class: "o-col w-1/5" }
const _hoisted_11 = { class: "o-form-group__item" }
const _hoisted_12 = { class: "o-mselect__wrap" }
const _hoisted_13 = { class: "o-col w-1/5" }
const _hoisted_14 = { class: "o-form-group__item" }
const _hoisted_15 = { class: "o-mselect__wrap" }
const _hoisted_16 = { class: "o-col w-1/5" }
const _hoisted_17 = { class: "o-form-group__item" }
const _hoisted_18 = { class: "o-mselect__wrap" }
const _hoisted_19 = { class: "option__desc" }
const _hoisted_20 = { class: "option__title" }
const _hoisted_21 = {
  slot: "tag",
  "slot-scope": "{ option, remove }"
}
const _hoisted_22 = { class: "multiselect__tag" }
const _hoisted_23 = { class: "o-col w-1/5" }
const _hoisted_24 = { class: "o-form-group__item" }
const _hoisted_25 = { class: "o-mselect__wrap" }
const _hoisted_26 = {
  class: "o-form__active-filters",
  style: {"display":"none"}
}
const _hoisted_27 = { class: "o-form__active-filters__item" }
const _hoisted_28 = { class: "o-form__active-filters__item__label" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "o-form__active-filters__item" }
const _hoisted_31 = { class: "o-form__active-filters__item__label" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "o-form__active-filters__item" }
const _hoisted_34 = { class: "o-form__active-filters__item__label" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "o-form__active-filters__item" }
const _hoisted_37 = { class: "o-form__active-filters__item__label" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "o-form__active-filters__item" }
const _hoisted_40 = { class: "o-form__active-filters__item__label" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 0,
  class: "o-form__active-filters__reset"
}
const _hoisted_43 = {
  key: 0,
  class: "o-section"
}
const _hoisted_44 = { class: "o-section" }
const _hoisted_45 = { class: "o-container" }
const _hoisted_46 = { class: "o-row" }
const _hoisted_47 = { class: "o-col" }
const _hoisted_48 = { class: "c-showroom__title" }
const _hoisted_49 = { class: "c-showroom__nav" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "c-showroom-cars" }
const _hoisted_53 = { class: "js-showroom-car c-showroom-car_item" }
const _hoisted_54 = { class: "c-showroom-car_image" }
const _hoisted_55 = ["href"]
const _hoisted_56 = ["src"]
const _hoisted_57 = {
  key: 0,
  class: "c-showroom-date__wrapper"
}
const _hoisted_58 = ["href"]
const _hoisted_59 = ["href"]
const _hoisted_60 = ["href"]
const _hoisted_61 = { class: "c-showroom-car_name" }
const _hoisted_62 = ["href"]
const _hoisted_63 = { key: 0 }
const _hoisted_64 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")
  const _component_svgIco = _resolveComponent("svgIco")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "o-col w-1/12 -empty" }, null, -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_4, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "o-text -center" }, [
              _createElementVNode("h2", {
                class: "o-h3",
                style: {"margin-bottom":"2.5rem"}
              }, "Filtrez votre recherche")
            ], -1 /* HOISTED */)),
            _createElementVNode("form", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[7] || (_cache[7] = _createElementVNode("label", {
                      class: "o-label sr-only",
                      for: "marques"
                    }, "Marques", -1 /* HOISTED */)),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_VueMultiselect, {
                        "selected-label": "Actif",
                        modelValue: $data.selectedMakes,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.selectedMakes) = $event)),
                        options: $data.makes,
                        placeholder: "Marque",
                        multiple: true
                      }, null, 8 /* PROPS */, ["modelValue", "options"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[8] || (_cache[8] = _createElementVNode("label", { class: "o-label sr-only" }, "Modèles", -1 /* HOISTED */)),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_VueMultiselect, {
                        "selected-label": "Actif",
                        modelValue: $data.selectedModels,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.selectedModels) = $event)),
                        options: $options.getModelsForMake($data.selectedMakes),
                        placeholder: "Modèles",
                        multiple: true
                      }, null, 8 /* PROPS */, ["modelValue", "options"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", { class: "o-label sr-only" }, "Type de véhicule", -1 /* HOISTED */)),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_VueMultiselect, {
                        "selected-label": "Actif",
                        modelValue: $data.selectedTypes,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.selectedTypes) = $event)),
                        options: $data.cats,
                        placeholder: "Type de véhicule",
                        multiple: true
                      }, null, 8 /* PROPS */, ["modelValue", "options"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _cache[11] || (_cache[11] = _createElementVNode("label", { class: "o-label sr-only" }, "Type de carburant", -1 /* HOISTED */)),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_VueMultiselect, {
                        "selected-label": "Actif",
                        modelValue: $data.selectedCarburants,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.selectedCarburants) = $event)),
                        options: $data.carburants,
                        placeholder: "Type de carburant",
                        multiple: true
                      }, {
                        option: _withCtx((props) => [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("span", _hoisted_20, _toDisplayString($data.carburantText[props.option]), 1 /* TEXT */)
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("template", _hoisted_21, [
                            _createElementVNode("span", _hoisted_22, [
                              _createElementVNode("span", null, _toDisplayString($data.carburantText[_ctx.option]), 1 /* TEXT */),
                              _cache[10] || (_cache[10] = _createTextVNode()),
                              _createElementVNode("i", {
                                onClick: _cache[3] || (_cache[3] = $event => (_ctx.remove(_ctx.option))),
                                "aria-hidden": "true",
                                tabindex: "1",
                                class: "multiselect__tag-icon"
                              })
                            ])
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["modelValue", "options"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _cache[12] || (_cache[12] = _createElementVNode("label", { class: "o-label sr-only" }, "Fourchette de prix", -1 /* HOISTED */)),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_VueMultiselect, {
                        "selected-label": "Actif",
                        modelValue: $data.selectedRanges,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.selectedRanges) = $event)),
                        options: ['0-20000','20000-30000','30000-40000','40000-50000','50000-60000','60000-70000','70000-80000','80000-90000','90000-200000'],
                        placeholder: "Fourchette de prix",
                        multiple: true
                      }, null, 8 /* PROPS */, ["modelValue"])
                    ])
                  ])
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_26, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.selectedMakes, (make) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, _toDisplayString(make), 1 /* TEXT */),
                  _createElementVNode("button", {
                    class: "o-form__active-filters__item__remove",
                    onClick: _withModifiers($event => ($options.removeMake(make)), ["prevent"])
                  }, [
                    _createVNode(_component_svgIco, { icon: "close" })
                  ], 8 /* PROPS */, _hoisted_29)
                ]))
              }), 256 /* UNKEYED_FRAGMENT */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.selectedModels, (model) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("span", _hoisted_31, _toDisplayString(model), 1 /* TEXT */),
                  _createElementVNode("button", {
                    class: "o-form__active-filters__item__remove",
                    onClick: _withModifiers($event => ($options.removeModel(model)), ["prevent"])
                  }, [
                    _createVNode(_component_svgIco, { icon: "close" })
                  ], 8 /* PROPS */, _hoisted_32)
                ]))
              }), 256 /* UNKEYED_FRAGMENT */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.selectedTypes, (cat) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("span", _hoisted_34, _toDisplayString(cat), 1 /* TEXT */),
                  _createElementVNode("button", {
                    class: "o-form__active-filters__item__remove",
                    onClick: _withModifiers($event => ($options.removeType(cat)), ["prevent"])
                  }, [
                    _createVNode(_component_svgIco, { icon: "close" })
                  ], 8 /* PROPS */, _hoisted_35)
                ]))
              }), 256 /* UNKEYED_FRAGMENT */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.selectedCarburants, (cat) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createElementVNode("span", _hoisted_37, _toDisplayString($data.carburantText[cat]), 1 /* TEXT */),
                  _createElementVNode("button", {
                    class: "o-form__active-filters__item__remove",
                    onClick: _withModifiers($event => ($options.removeCarburant(cat)), ["prevent"])
                  }, [
                    _createVNode(_component_svgIco, { icon: "close" })
                  ], 8 /* PROPS */, _hoisted_38)
                ]))
              }), 256 /* UNKEYED_FRAGMENT */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.selectedRanges, (cat) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createElementVNode("span", _hoisted_40, _toDisplayString(cat), 1 /* TEXT */),
                  _createElementVNode("button", {
                    class: "o-form__active-filters__item__remove",
                    onClick: _withModifiers($event => ($options.removeRange(cat)), ["prevent"])
                  }, [
                    _createVNode(_component_svgIco, { icon: "close" })
                  ], 8 /* PROPS */, _hoisted_41)
                ]))
              }), 256 /* UNKEYED_FRAGMENT */)),
              ($data.selectedMakes.length || $data.selectedModels.length || $data.selectedTypes.length || $data.selectedCarburants.length || $data.selectedRanges.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createElementVNode("button", {
                      type: "button",
                      name: "button",
                      class: "o-button -reset",
                      onClick: _cache[6] || (_cache[6] = _withModifiers((...args) => ($options.resetSearch && $options.resetSearch(...args)), ["prevent"]))
                    }, _cache[13] || (_cache[13] = [
                      _createElementVNode("span", { class: "o-button__text" }, "Réinitialiser", -1 /* HOISTED */)
                    ]))
                  ]))
                : _createCommentVNode("v-if", true)
            ], 512 /* NEED_PATCH */), [
              [_vShow, $data.loaded]
            ])
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "o-col w-1/12 -empty" }, null, -1 /* HOISTED */))
        ])
      ])
    ]),
    (!$options.filteredItems.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_43, _cache[17] || (_cache[17] = [
          _createElementVNode("div", { class: "o-container" }, [
            _createElementVNode("div", { class: "o-row" }, [
              _createElementVNode("div", { class: "o-col" }, [
                _createElementVNode("h2", { class: "c-showroom__title" }, "Aucun véhicule trouvé")
              ])
            ])
          ], -1 /* HOISTED */)
        ])))
      : _createCommentVNode("v-if", true),
    ($options.filteredMakes.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($data.filteredMakesData, (curMake) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            _createElementVNode("section", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("h2", _hoisted_48, "Explorez les modèles " + _toDisplayString(curMake.name), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["c-showroom__nav__item", {'is-active': curMake.showAll}]),
                        onClick: $event => (curMake.showAll=true)
                      }, " Voir tout ", 10 /* CLASS, PROPS */, _hoisted_50),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(curMake.cats, (cat) => {
                        return (_openBlock(), _createElementBlock("button", {
                          class: _normalizeClass(["c-showroom__nav__item", {'is-active':!curMake.showAll && cat.selected}]),
                          onClick: $event => {cat.selected=true;curMake.showAll=false;$options.checkCat(cat,curMake);}
                        }, _toDisplayString(cat.name), 11 /* TEXT, CLASS, PROPS */, _hoisted_51))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredItemsIn(curMake), (item) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("a", {
                              href: item.url
                            }, [
                              _createElementVNode("img", {
                                src: item.image,
                                alt: "",
                                style: {"min-width":"100%"}
                              }, null, 8 /* PROPS */, _hoisted_56)
                            ], 8 /* PROPS */, _hoisted_55)
                          ]),
                          (item.prev)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                _createElementVNode("a", {
                                  href: item.url,
                                  class: "c-showroom-date -actual"
                                }, _toDisplayString(item.annee), 9 /* TEXT, PROPS */, _hoisted_58),
                                _createElementVNode("a", {
                                  href: item.prev.url,
                                  class: "c-showroom-date -old"
                                }, _toDisplayString(item.prev.annee), 9 /* TEXT, PROPS */, _hoisted_59),
                                (item.prev2)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: item.prev2.url,
                                      class: "c-showroom-date -old"
                                    }, _toDisplayString(item.prev2.annee), 9 /* TEXT, PROPS */, _hoisted_60))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("a", {
                              href: item.url
                            }, [
                              _createTextVNode(_toDisplayString(item.model) + " ", 1 /* TEXT */),
                              ($options.hasPrix(item))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_63, "À partir de " + _toDisplayString(_ctx.cash(item.prix)), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                            ], 8 /* PROPS */, _hoisted_62)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("a", {
                              href: item.url,
                              class: "c-showroom-car__button"
                            }, [
                              _cache[18] || (_cache[18] = _createElementVNode("span", null, "Choisir", -1 /* HOISTED */)),
                              _createVNode(_component_svgIco, { icon: "arrow-right" })
                            ], 8 /* PROPS */, _hoisted_64)
                          ])
                        ]))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ])
                ])
              ])
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "o-container -separator" }, [
              _createElementVNode("hr")
            ], -1 /* HOISTED */))
          ], 64 /* STABLE_FRAGMENT */))
        }), 256 /* UNKEYED_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}